import '../CsvJsonInfoPages.scss';


function ColourAndTrimLinks() {

    const data = [
        { field: 1, description: 'CAP Vehicle Identification Number' },
        { field: 2, description: 'Date (ddmmyyyy)' },
        { field: 3, description: 'Colour Code' },
        { field: 4, description: 'Trim Code' },
    ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data - Colour & Trim Links</h1>
            <p>Provides the relationships between colour (paint) options and Trim options showing valid combinations.<br /><br />
                <b>File Naming Convention</b><br /><br />
                The &lt;FILENAME&gt; is dependant on the product being produced as follows.
            </p>

            <b>Colour & Trim Link</b>
            <p>CCTCOMB.??? CARS<br />
                LCTCOMB.??? LIGHT COMMERCIALS<br />
                HCTCOMB.??? HEAVY COMMERCIALS<br />
                BCTCOMB.??? BIKES<br /><br />

                The 3 question marks (???) on each of the above files will be replaced with the day i.e. J12 for January 12th.
            </p>

            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default ColourAndTrimLinks;
